import React from "react";
import styled from "styled-components";

// PUTTING THIS REUSABLE TO BODY AND MIND AND ADVERTISING
export const CustomRange = styled.input.attrs({ type: "range" })`
    height: 4px;
    width: 100%;
    background: transparent;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;

    /* Base track styles */
    &::-webkit-slider-runnable-track {
        height: 4px;
        background: linear-gradient(
            to right,
            white 0%,
            white ${({ value, max }) => (value / max) * 100}%,
            #ccc ${({ value, max }) => (value / max) * 100}%,
            #ccc 100%
        );
        border-radius: 2px;
    }

    &::-moz-range-track {
        height: 4px;
        background: linear-gradient(
            to right,
            white 0%,
            white ${({ value, max }) => (value / max) * 100}%,
            #ccc ${({ value, max }) => (value / max) * 100}%,
            #ccc 100%
        );
        border-radius: 2px;
    }

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
        margin-top: -3px;
        position: relative;
        z-index: 1;
    }

    &::-moz-range-thumb,
    &::-ms-thumb {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
        border: none;
    }
`;

export const VideoBottomControls = styled.div`
    position: absolute;
    bottom: 10px;
    left: 12px;
    right: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    z-index: 10;
    pointer-events: auto;
    opacity: ${({ show }) => (show ? 1 : 0)};
    transition: opacity 0.3s ease;
    pointer-events: ${({ show }) => (show ? "auto" : "none")};
`;

export const VideoContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 12px;
`;

export const VideoControlsBar = styled.div`
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${p => p.fontSize || "0.87rem"};
    font-family: monospace;
    color: #fff;
    pointer-events: ${({ interactive }) => (interactive ? "auto" : "none")};
`;

export const ControlButton = styled.button`
    width: 20px;
    height: 20px;
    min-width: 24px;
    min-height: 24px;
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media (max-width: 480px) {
        width: 28px;
        height: 28px;
    }
`;


export const PlayIcon = () => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="white">
        <path d="M8 5v14l11-7z" />
    </svg>
);

export const PauseIcon = () => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="white">
        <path d="M6 19h4V5H6zm8-14v14h4V5h-4z" />
    </svg>
);

export const VolumeIcon = ({ muted, volume = 1 }) => {
    if (muted || volume === 0) {
        return (
            <svg width="100%" height="100%" fill="white" viewBox="0 0 24 24">
                <path d="M16.5 12L19 14.5 17.5 16 15 13.5 12.5 16 11 14.5 13.5 12 11 9.5 12.5 8 15 10.5 17.5 8 19 9.5z" />
                <path d="M5 9v6h4l5 5V4l-5 5H5z" />
            </svg>
        );
    } else if (volume < 0.5) {
        return (
            <svg width="100%" height="100%" fill="white" viewBox="0 0 24 24">
                <path d="M5 9v6h4l5 5V4l-5 5H5z" />
                <path d="M15.5 12c0-.83-.5-1.54-1.22-1.84v3.68c.72-.3 1.22-1.01 1.22-1.84z" />
            </svg>
        );
    } else {
        return (
            <svg width="100%" height="100%" fill="white" viewBox="0 0 24 24">
                <path d="M5 9v6h4l5 5V4l-5 5H5z" />
                <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.06c1.48-.74 2.5-2.26 2.5-4.03z" />
                <path d="M18.5 12c0 2.53-1.39 4.71-3.5 5.93v-2.17c1.22-.83 2-2.19 2-3.76s-.78-2.93-2-3.76V6.07c2.11 1.22 3.5 3.4 3.5 5.93z" />
            </svg>
        );
    }
};

export const FullscreenIcon = () => (
    <svg width="100%" height="100%" fill="white" viewBox="0 0 24 24">
        <path d="M7 14H5v5h5v-2H7v-3zM19 14h-2v3h-3v2h5v-5zM5 5v5h2V7h3V5H5zM19 5h-5v2h3v3h2V5z" />
    </svg>
);

export const formatTime = (sec) => {
    const rounded = Math.round(sec);
    const m = String(Math.floor(rounded / 60)).padStart(2, "0");
    const s = String(rounded % 60).padStart(2, "0");
    return `${m}:${s}`;
};